
import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getCanonicalProductNames } from '@/services/benchmark/productNameMapping';

interface ProductNameFieldProps {
  productName: string;
  onProductNameChange: (value: string) => void;
}

export const ProductNameField: React.FC<ProductNameFieldProps> = ({
  productName,
  onProductNameChange
}) => {
  const [productOpen, setProductOpen] = useState(false);
  const availableProducts = getCanonicalProductNames();

  return (
    <div className="space-y-2">
      <Label>Product Name *</Label>
      <Popover open={productOpen} onOpenChange={setProductOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            role="combobox"
            aria-expanded={productOpen}
            className="w-full justify-between"
          >
            {productName || "Select product..."}
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-full p-0" align="start">
          <Command>
            <CommandInput placeholder="Search products..." />
            <CommandList>
              <CommandEmpty>No product found.</CommandEmpty>
              <CommandGroup>
                {availableProducts.map((product) => (
                  <CommandItem
                    key={product}
                    value={product}
                    onSelect={(currentValue) => {
                      onProductNameChange(currentValue);
                      setProductOpen(false);
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        productName === product ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {product}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
      <Input
        placeholder="Or type custom product name"
        value={productName}
        onChange={(e) => onProductNameChange(e.target.value)}
      />
    </div>
  );
};
